export const colors = {
	red: "#a00a18",
};
